import LocalizedStrings from 'react-localization';

const t = new LocalizedStrings({
    en: {
        benefits: "Benefits",
        topSelling:"Top Selling",
        numberOfViews: "Number of views is approximate & depends on the number of users",
        byPurchasingThe:"By purchasing the service you agree to the",
        termsOfUse: "Terms of Use",
        privacyPolicy: "Privacy Policy",
        doYouNeedHelp: "Do you need help?",
        contactUs: "Contact Us",
        adsLeft: "Ads Left",
        buyNow: "Continue",
        useBundle: "Use",
        credit: "Credit",
        package_used: "The package has been used successfully",
        package_used_more_effective: "You can now benefit from more effective ads",
        done: "Done",
        useBundleConfirmation:"Are you sure you want to use this Bundle?",
        approveText:"Yes",
        rejectText:"No"


    },
    ar: {
        benefits: "الميزات",
        topSelling:"الأكثر مبيعاً",
        numberOfViews:"عدد المشاهدات تقريبي ويعتمد على عدد المستخدمين",
        byPurchasingThe:"بشرائك الخدمة ، فإنك توافق على",
        termsOfUse: "اتفاقية الاستخدام",
        privacyPolicy: "سياسة المحتوى",
        doYouNeedHelp: "هل تحتاج مساعدة؟",
        contactUs: "اتصل بنا",
        adsLeft: "إعلانات متبقية",
        buyNow: "استمر",
        useBundle: "استخدم ",
        credit: "رصيد",
        package_used: "تم استخدام الحزمه بنجاح",
        package_used_more_effective: "بامكانك الان الاستفاده من المزيد من الاعلانات الفعالة!",
        done:"تم",
        useBundleConfirmation:"هل انت متأكد من استخدام الحزمة؟",
        approveText:"نعم",
        rejectText:"لا"


    }
})

export default t